import React from "react";
import { Link } from "react-router-dom";
import _ from "lodash";

export const BreadCrumb = (props) => {
  const { navigationSettings } = props;

  const { rootModule, parentModule, activeModule } = navigationSettings;

  const standardizeDisplayText = (module) =>
    module.standardized ? _.startCase(module.name) : module.name;

  return (
    <div className="breadcrumb">
      <div>
        <strong>{standardizeDisplayText(activeModule)}</strong>
      </div>
      <ol className="right">
        {rootModule && (
          <li>
            <a>{standardizeDisplayText(rootModule)}</a>
            <span className="divider">/</span>
          </li>
        )}
        {parentModule && (
          <li>
            {!_.isNil(rootModule) ? (
              <Link
                to={{ pathname: `/${parentModule.identifier}` }}
                style={{ color: "inherit", textDecoration: "none" }}
              >
                {standardizeDisplayText(parentModule)}
              </Link>
            ) : (
              <a>{standardizeDisplayText(parentModule)}</a>
            )}
            <span className="divider">/</span>
          </li>
        )}
        <li>
          <a>{standardizeDisplayText(activeModule)}</a>
        </li>
      </ol>
    </div>
  );
};
